import React, { ReactNode } from "react"
import { Control } from "react-hook-form"
import { Box } from "@chakra-ui/react"
import FormDetailHeader from "../FormDetailHeader"
import BasicInputs from "../BasicInputs/BasicInputs"

type Props = {
  control: Control<object, any>
  eventId: string
  name: string
  currency: string
  sendConfirmationEmails: boolean
  quantityHelperText?: ReactNode
}

const Ticket = ({
  control, eventId, name, currency, sendConfirmationEmails, quantityHelperText,
}: Props) => (
  <Box pb={6}>
    <FormDetailHeader
      name={name}
      description="Enables ticket sales with a streamlined checkout experience for guests or through the point-of-sale integration on the Diobox mobile app."
    />
    <BasicInputs
      control={control}
      eventId={eventId}
      showVisibilityInput
      showQuantityInput
      quantityHelperText={quantityHelperText}
      showLimitPerSubmission
      showPrice
      currency={currency}
      showGuestCreation
      sendConfirmationEmails={sendConfirmationEmails}
    />
  </Box>
)

export default Ticket
